module.exports = __webpack_public_path__ + "img/loupe-grey.c327743b.svg";